import axios from "axios";

const request = axios.create({
  baseURL: "https://blog-application-backend-green.vercel.app",
});

export default request;
